<template>
  <div
    style="min-height: calc(100vh - 160px)"
    v-loading="homeLoading"
    element-loading-text="数据处理中......"
  >
    <div class="title">
      <div class="title--newFont">
        <span v-if="returnMaterial_type == 0">{{ $t("新增退料单") }}</span>
        <span v-if="returnMaterial_type == 1">{{ $t("修改退料单") }}</span>
      </div>
      <div style="text-align: right">
        <el-button
          class="btnOne"
          size="mini"
          @click="saveData"
          :loading="btnLoading"
          :disabled="btnLoading"
          >{{ $t("提交") }}</el-button
        >
        <el-button class="btnTwo" size="mini" @click="backHome">{{
          $t("返回")
        }}</el-button>
      </div>
    </div>
    <hr />
    <!-- 操作栏 -->
    <div style="margin-bottom: 10px">
      <el-descriptions direction="horizontal" :column="3" border>
        <el-descriptions-item>
          <template slot="label">
            <div>
              <el-tooltip
                class="item"
                effect="dark"
                :content="
                  $t('若您不输入退料单号') +
                  '，' +
                  $t('系统将为您按照编码心情所配置自动生成')
                "
                placement="top"
              >
                <span class="el-icon-question">{{ $t("退料单号") }}</span>
              </el-tooltip>
            </div>
          </template>
          <el-input
            v-model="addData.outsourcingReturnDocNumber"
            :placeholder="$t('退料单号')"
            class="input"
          ></el-input>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">{{ $t("全局搜索码") }}</template>
          <el-input
            v-model="addData.globalSearchNumber"
            :placeholder="$t('全局搜索码')"
            class="input"
          ></el-input>
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">{{ $t("退料日期") }}</template>
          <el-date-picker
            style="width: 100%"
            v-model="addData.baseReturnTime"
            type="date"
            value-format="yyyy-MM-dd"
            :placeholder="$t('退料日期')"
          >
          </el-date-picker>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <!-- 内容 -->
    <div>
      <myTable
        :id="'myTableOne'"
        :columnType="'columnIndex'"
        :list="itemList"
        :titleList="itemTitleList"
        :tableBtnList="itemTableBtnList"
        @btnClick="productBtnClick"
        ref="myTableOne"
      ></myTable>
    </div>
    <div>
      <el-input
        type="textarea"
        v-model="addData.remark"
        :placeholder="$t('备注')"
        rows="5"
      ></el-input>
    </div>
  </div>
</template>
<script>
import {
  divFloat,
  mulFloat,
  accAdd,
  subFloat,
  year,
  month,
  day,
  _debounce,
} from "@/utils/myUtils";
import {
  outsorReturnDoc_add,
  outsorReturnDoc_update,
} from "@/api/myController/outsourcing";
export default {
  props: {
    // 页面传进来判断的值
    routeType: {
      type: Array,
      default: undefined,
    },
    // 页面传进来的值
    routeQuery: {
      default: () => ({}),
    },
    homeIndex: {
      type: Number,
      default: false,
    },
    returnMaterial_type: {
      type: Number,
      default: 0,
    },
    itemList: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    },
    // 新增数据
    addData: {
      default: () => ({
        outsourcingReturnDocNumber: null,
        globalSearchNumber: null,
        baseConfirmmanId: null,
        baseConfirmmanName: null,
        baseDrawerId: null,
        baseDrawerName: null,
        baseOutsourcingDocId: null,
        baseReturnTime: null,
        baseReturnWarehouseId: null,
      }),
    },
  },
  components: {},
  data() {
    return {
      btnLoading: false,
      homeLoading: false,
      // ------------------基础数据
      itemTableBtnList: [this.$t("删除")],
      itemTitleList: [
        {
          id: 0,
          name: this.$t("产品编号"), //必传
          value: "baseMaterialNumber", //必传
          fixedState: false, //是否固定     //必传
          isShow: true, //是否显示          //必传
          dataType: "text", //必传
          canEdit: false, //是否不可编辑，rue可编辑，false不可编辑
        },
        {
          id: 1,
          name: this.$t("产品名称"), //必传
          value: "baseMaterialName", //必传
          fixedState: false, //是否固定     //必传
          isShow: true, //是否显示          //必传
          dataType: "text", //必传
          canEdit: true, //是否不可编辑，rue可编辑，false不可编辑
        },
        {
          id: 2,
          name: this.$t("规格型号"), //必传
          value: "specifications", //必传
          fixedState: false, //是否固定     //必传
          isShow: true, //是否显示          //必传
          dataType: "textList", //必传
          canEdit: false, //是否不可编辑，rue可编辑，false不可编辑
        },
        {
          id: 2,
          name: this.$t("客户料号"),
          value: "baseCustomerMaterialNumber",
          fixedState: false,
          isShow: true,
          dataType: "text",
          alwaysEditState: false,
          canEdit: false,
          width: 180,
        },
        {
          id: 6,
          name: this.$t("单位"), //必传
          value: "baseMaterialUnitName", //必传
          fixedState: false, //是否固定     //必传
          isShow: true, //是否显示          //必传
          dataType: "text", //必传
          canEdit: false, //是否不可编辑，rue可编辑，false不可编辑
        },
        {
          id: 10,
          name: this.$t("可退料数量"),
          value: "valueMaterialQuantity",
          fixedState: false,
          isShow: true,
          dataType: "number",
          canEdit: false,
          alwaysEditState: false,
          width: 180,
        },
        {
          id: 10,
          name: this.$t("退料数量"),
          value: "baseReturnQuantity",
          fixedState: false,
          isShow: true,
          dataType: "number",
          canEdit: true,
          alwaysEditState: true,
          width: 180,
        },
        {
          id: 11,
          name: this.$t("备注"),
          value: "remark",
          fixedState: false,
          isShow: true,
          dataType: "textarea",
          canEdit: true,
          alwaysEditState: true,
          width: 180,
        },
      ],
      // 转单数据
      sysDocRelationDto: {
        baseMaterialFromPrice: 0,
        baseMaterialId: 0,
        baseMaterialSpecgroupId: 0,
        baseMaterialToPrice: 0,
        createDeptId: 0,
        relationDocDetailFromId: 0,
        relationDocDetailToId: 0,
        relationDocFromId: 0, //来源单据ID
        relationDocToId: 0,
        relationId: 0,
        relationType: 0, //0.不正常，2.正常
        remark: "",
        searchString: "",
        valueMaterialQuantity: 0,
      },
    };
  },
  created() {
    // 委外退料
    if (this.routeType && this.routeType == 1) {
      this.sysDocRelationDto.relationDocFromId = this.routeQuery.outsourcingDocId;
      this.productHandle(this.routeQuery);
    }
    if (this.returnMaterial_type == 0) {
      this.getList();
    }
  },
  methods: {
    // 多语言
    $t(value) {
      return value;
    },
    //
    getList() {
      this.addData.baseReturnTime = year() + "-" + month() + "-" + day();
      this.addData.baseDrawerId = this.getUserInfo.userId;
      this.addData.baseDrawerName = this.getUserInfo.showName;
      this.addData.baseConfirmmanId = this.getUserInfo.userId;
      this.addData.baseConfirmmanName = this.getUserInfo.showName;
    },
    // 处理数量
    productHandle(row) {
      this.itemList = [];
      this.addData.baseOutsourcingDocId = row.outsourcingDocId;
      this.addData.globalSearchNumber = row.globalSearchNumber;
      row.outsourcingDocMaterialList.forEach((item) => {
        try {
          item.specifications = JSON.parse(item.baseMaterialSpecDesc);
        } catch (error) {}
        item.baseReturnQuantity = item.valueMaterialQuantity;
        item.baseWarehouseName = "";
      });
      this.itemList = row.outsourcingDocMaterialList;
    },
    productBtnClick(row, item, index, state) {
      switch (item) {
        case this.$t("删除"):
          this.itemList.splice(index - 1, 1);
          break;
        default:
          break;
      }
    },
    getBackOrderState() {
      this.$emit("backOrderState");
    },
    async saveData() {
      this.$requestRepeat(2000, "outsourcing_returnMaterial_add_saveData");
      let costomState = true;
      this.itemList.forEach((item) => {
        if (!item.baseReturnQuantity || item.baseReturnQuantity <= 0) {
          costomState = false;
        }
      });
      if (costomState == false) {
        this.$message.error(this.$t("数量不可为空"));
        return;
      }
      this.btnLoading = true;
      this.itemList.forEach((item) => {
        item.baseProduceWarehouseId = item.produceWarehouseId;
        item.baseOutsourcingDocId = item.baseProduceId;
        item.baseRequisitionDocDetailId = item.materialRequisitionDocDetailId;
        item.baseReturnQuantity = parseFloat(item.baseReturnQuantity);
        item.baseSpecGroupId = item.baseSpecGroupId;
        item.baseSpecgroupDesc = item.baseSpecgroupDesc;
      });
      let json = {
        outsorReturnDocDto: this.addData,
        outsorReturnDocDetailDtoList: this.itemList,
        sysDocRelationDto: this.sysDocRelationDto,
      };
      if (this.returnMaterial_type == 0) {
        await outsorReturnDoc_add(json)
          .then((res) => {
            this.$message.success(this.$t("操作成功") + "！");
            this.btnLoading = false;
            json = {
              returnDocId: res.data.data,
            };
            this.$emit("backHome", 49, json);
          })
          .catch((error) => {
            this.btnLoading = false;
          });
      } else {
        await outsorReturnDoc_update(json)
          .then((res) => {
            this.$message.success(this.$t("操作成功") + "！");
            this.btnLoading = false;
          })
          .catch((error) => {
            this.btnLoading = false;
          });
      }
    },
    backHome() {
      this.$emit("backHome");
    },
  },
};
</script>
<style scoped>
.input {
  width: 100%;
}

.btnOne {
  background: #08a1b8;
  color: white;
}

.title {
  display: flex;
  position: relative;
  margin-bottom: 10px;
}

.title----font {
  color: rgb(8, 161, 184);
  position: relative;
  margin-left: 47%;
  font-size: 25px;
  font-weight: bold;
}

.title--button {
  position: absolute;
  margin-left: 1px;
  margin-top: 0.1%;
}
</style>
